import React, { useState, useEffect } from 'react';
import './../App.css';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';
import ApiService from '../services/ApiService';
import AnimeCardComponent from '../components/animecard/AnimeCardComponent';

const AllAnimePage = () => {
    const [animeList, setAnimeList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [thatsAll, setThatsAll] = useState(false);

    let lastFetchPage = -1; // Use 'let' instead of 'var'

    const fetchData = async (locPage) => {
        if (thatsAll || lastFetchPage === locPage || loading) return; // Exit if already loading or all data has been fetched
        try {
            setLoading(true);
            lastFetchPage = locPage;
            const data = await ApiService.getPublicAnimeList(locPage);
            if (data.type === "success") {
                if (data.data.length === 0) {
                    setThatsAll(true); // Set flag indicating all data has been fetched
                } else {
                    setAnimeList(prevAnimeList => [...prevAnimeList, ...data.data]);
                }
            } else {
                console.error('Error fetching anime list:', data);
            }
        } catch (error) {
            console.error('Error fetching anime list:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleScroll = () => {
        const position = window.scrollY + window.innerHeight;
        const bottom = document.documentElement.offsetHeight;
        const buffer = 500; // 500px buffer before reaching bottom
        
        // Load more when within 500px of the bottom
        if (position >= bottom - buffer && !loading && !thatsAll) {
            setPage(prevPage => prevPage + 1); // Increment page when scrolled to near bottom
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [loading, thatsAll]); // Add dependencies to prevent multiple triggers

    useEffect(() => {
        const checkAndFetchMore = async () => {
            await fetchData(page);
            // If content doesn't fill the page, load more immediately
            if (document.documentElement.offsetHeight <= window.innerHeight + 500 && !thatsAll && !loading) {
                setPage(prevPage => prevPage + 1);
            }
        };

        checkAndFetchMore();
    }, [page]); // Fetch data when page changes

    useEffect(() => {
        document.title = 'animix - Недавно обновлено';
    }, []);

    return (
        <PageShell sidebar className="catalog-page">
            <PageHeader title="Недавно обновлено" />
            <div className="anime-container">
                {animeList.map((anime, index) => (
                    <AnimeCardComponent key={index} anime={anime} isInteractive={true} />
                ))}
            </div>
            {loading && <p className="ui-status">Загружаем больше…</p>}
            {thatsAll && <p className="ui-status">Это всё недавно загруженное аниме.</p>}
        </PageShell>
    );
};

export default AllAnimePage;
